jQuery(document).ready(function($){

    function wc_store_notice_position() {
        if($('.woocommerce-store-notice').length) {
            var height = $('.woocommerce-store-notice').outerHeight();
            $('body').css('padding-top', height + 'px');
        }        
    }

    wc_store_notice_position();

    $(window).resize(function() {
        wc_store_notice_position();
    });
});